<template>
  <b-container fluid class="h-100-trim-header-footer" id="tailieWidget">
    <ui-header backButton="True" />
    <b-row>
      <b-col md="12" id="tailie-forgot-password">
        <div id="tailie-password">
          <p class="tailieTitle">{{ $t("password-request-main-title") }}</p>
          <p class="tailieSubTitle">{{ $t("password-request-sub-title") }}</p>
          <b-form @submit="onSubmit">
            <b-form-group
              id="label-sidebar-email"
              :label="$t('email')"
              label-for="input-sidebar-email"
              label-class="tailie-input-label"
              label-id="tailieEmailLabel"
            >
              <b-form-input
                id="input-sidebar-email"
                class="tailie-input"
                v-model="form.email"
                type="email"
                required
              />
            </b-form-group>
            <b-button
              type="submit"
              variant="primary"
              class="tailie-tab tailieBluebutton tailieSendEmailPassword margin-top-15"
            >
              {{ $t("password-request-send-code") }}
            </b-button>
          </b-form>
          <b-button
            @click="$router.push({ name: 'login' })"
            variant="link"
            class="mt-2 text-black"
            >{{ $t("password-confirmation-code-back") }}
          </b-button>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import UiHeader from "../../components/ui/app-header";

export default {
  name: "pages-auth-password-reset-request",
  components: {
    UiHeader
  },
  data() {
    return {
      form: {
        email: ""
      }
    };
  },
  created() {
    // this.$store.dispatch("ui/setSize", {
    //   width: 898,
    //   height: 698
    // });
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$store.commit("ui/SET_LOADING_TEXT", "Requesting password request!");
      this.$store.commit("ui/SET_LOADING", true);
      this.$store
        .dispatch("users/requestPasswordReset", this.form.email)
        .then(() => {
          this.$store.commit("ui/SET_LOADING", false);
          this.$router.push({ name: "password-reset-confirmation" });
        })
        .catch(() => this.$store.commit("ui/SET_LOADING", false));
    }
  }
};
</script>
